import { useTranslate } from '@tolgee/react'
import axios from 'axios'
import { ViewContext } from 'components/lib'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { ChatbotsCarousel } from '../ChatbotsCarousel'
import { useSearchParams } from 'react-router-dom'
import { Search, Verified } from '@mui/icons-material'
import SectionSkeletonLoader from './SectionSkeletonLoader'
import Divider from '../Divider'

export const Popular = ({ filter, signal, refetchData, clearSearch, searchHintsUI }) => {
  const context = useContext(ViewContext)
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const { t } = useTranslate()
  const params = useSearchParams()[0]
  const [numberPages, setNumberPages] = useState(1)
  const [totalChatbots, setTotalChatbots] = useState(0)

  const fetchItems = useCallback(async () => {
    setLoading(true)
    try {
      const category = params.get('category')
      const res = await axios.get(
        `/api/chat-bot/library/popular?page=${numberPages}&pageSize=10&filter=${filter}&period=ever${category ? `&category=${category}` : ''}`
      )
      if (numberPages === 1) setItems(res.data?.chatBots)
      else setItems((prev) => [...prev, ...res.data?.chatBots])
      setTotalChatbots(res.data?.total)
    } catch (err) {
      context.handleError(err)
    } finally {
      setLoading(false)
    }
  }, [filter, params, numberPages])

  useEffect(() => {
    fetchItems()
  }, [fetchItems, signal])

  if (loading && !items.length) return <SectionSkeletonLoader />
  if (!items.length) return

  const title = t('popular-chatbots-title', 'MOST POPULAR')

  return (
    <div className='bg-brand-background'>
      <ChatbotsCarousel
        items={items}
        title={title}
        total={totalChatbots}
        icon={<Verified sx={{ height: 18, width: 18 }} />}
        refetchData={refetchData}
        seeMoreUrl='/chatbot/library/popular'
        setNumberPages={setNumberPages}
      />
      <Divider />
    </div>
  )
}

export default Popular
